import React, { useContext } from 'react'
import { Col } from "react-bootstrap";
import { FormContext } from '../FormContext';
import "./customelements.css"

const Checkbox = ({ id, label, value, disabled, pivot, pivotreverse, mandatory, approval, show, md }) => {
    const check_value = value
    const check_pivot = pivot
    const check_pivot_reverse = pivotreverse
    const letShow = show===undefined ? true : show
    const { handleChange } = useContext(FormContext)
    // console.log("MD: ", md)
    const onChange = (event) => {
        event.stopPropagation()
        console.log("CHECKBOX event: ", event)
        handleChange(id, event)
    }
    return (
        <>
            {
                letShow ? (
                    check_pivot_reverse
                        ?
                        <Col md={md != undefined ? md : 12} className={check_pivot ? "pad-trbl-10 pivotreverse-check-holder" : "pad-trbl-10 custom-select-holder"}>
                            <label className="custom-checkbox-label move-left" htmlFor="exampleCheck1">{mandatory ? <span style={{ color: "red", marginRight: 5 }}>*</span> : ""}{label}</label>
                            <input type="checkbox" className={check_pivot ? "form-check-input move-left custom-check-input pivot-check" : "form-check-input move-left custom-check-input"} id="exampleCheck1" checked={check_value}
                                onChange={event => onChange(event)}
                                disabled={disabled}
                                required={mandatory}
                                autoComplete="new-password"
                            />
                        </Col>
                        :
                        <Col md={md != undefined ? md : 12} className={check_pivot ? "pad-trbl-10 pivot-check-holder" : "pad-trbl-10 custom-select-holder"}>
                            <label className="custom-checkbox-label move-left" htmlFor="exampleCheck1">{mandatory ? <span style={{ color: "red", marginRight: 5 }}>*</span> : ""}{label} &nbsp;{approval ? "(for approval)" : ""}</label>
                            <input type="checkbox" className={check_pivot ? "form-check-input move-left custom-check-input pivot-check" : "form-check-input move-left custom-check-input"} id="exampleCheck1" checked={check_value}
                                onChange={event => onChange(event)}
                                disabled={disabled}
                                required={mandatory}
                                autoComplete="new-password"
                            />
                        </Col>
                )
                    :
                    <></>
            }
        </>
    )
}

export default Checkbox